(() => {
  const boot = () => {
    const root = document.querySelector('[data-aw-configurator]');
    const panel = document.querySelector('[data-aw-p13-atelier-context]');
    if (!root || !panel) return;
    const params = new URLSearchParams(location.search);
    const handle = String(params.get('aw_service') || '').trim();
    if (!handle) return;
    const title = String(params.get('aw_service_title') || '').trim();
    root.dataset.awAtelierService = handle;
    panel.hidden = false;
    const titleNode = panel.querySelector('[data-aw-p13-service-title]');
    if (titleNode) titleNode.textContent = title || handle.replace(/-/g, ' ');
    const back = panel.querySelector('[data-aw-p13-service-return]');
    if (back) { back.href = '/products/' + encodeURIComponent(handle); back.hidden = false; }
    try { sessionStorage.setItem('aw_p13_service_context', JSON.stringify({ handle, title, capturedAt: Date.now() })); } catch (_) {}
    window.dispatchEvent(new CustomEvent('aw:p13-service-context', { detail: { handle, title: title || null } }));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
})();
(() => {
  const loaderScript = document.currentScript;
  const current = loaderScript && loaderScript.src;
  if (!current) return;
  const s = document.createElement('script');
  s.src = loaderScript.dataset.awPackSrc || new URL('aw-pack-p1-configurator.js', current).href;
  s.defer = true;
  s.dataset.awPackP1Loader = '1';
  document.head.appendChild(s);
})();

/* AW P5 Configurator context sync v1 — 2026-10-29. Fail-closed: never infer a platform from a model title. */
(() => {
  'use strict';
  const ROOT = '[data-aw-configurator]';
  const keys = {
    platform: 'aw_selected_platform',
    manufacturer: 'aw_selected_manufacturer',
    type: 'aw_selected_replica_type'
  };
  let syncing = false;
  let pending = null;

  const text = (value) => String(value == null ? '' : value).trim();
  const norm = (value) => text(value)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  const read = (key) => {
    try { return text(localStorage.getItem(key)); } catch (_) { return ''; }
  };
  const currentContext = () => {
    try {
      const ctx = window.AWAirsoftContext && typeof window.AWAirsoftContext.current === 'function'
        ? window.AWAirsoftContext.current()
        : null;
      if (!ctx || !text(ctx.platform)) return null;
      return {
        platform: text(ctx.platform),
        platformLabel: text(ctx.platformLabel || ctx.platform_label),
        manufacturer: text(ctx.manufacturer),
        replicaType: text(ctx.replicaType || ctx.type)
      };
    } catch (_) { return null; }
  };
  const collect = (detail) => {
    if (window.AWConfiguratorP22Blank === true) return null;
    const d = detail && typeof detail === 'object' ? detail : {};
    const ctx = currentContext();
    const platform = text(d.platform) || text(ctx && ctx.platform) || read(keys.platform);
    if (!platform) return null;
    return {
      platform,
      platformLabel: text(d.platformLabel) || text(ctx && ctx.platformLabel),
      manufacturer: text(d.manufacturer) || text(ctx && ctx.manufacturer) || read(keys.manufacturer),
      replicaType: text(d.replicaType || d.type) || text(ctx && ctx.replicaType) || read(keys.type)
    };
  };
  const remember = (detail) => {
    const next = collect(detail);
    if (!next) return;
    pending = Object.assign({}, pending || {}, next, { platform: next.platform });
  };
  const exactOptionValue = (select, value) => {
    if (!select || !value) return '';
    const wanted = norm(value);
    const option = Array.from(select.options).find((item) =>
      norm(item.value) === wanted || norm(item.textContent) === wanted
    );
    return option ? option.value : '';
  };
  const apply = () => {
    const root = document.querySelector(ROOT);
    if (!root || root.dataset.awReady !== 'true' || syncing) return false;
    const ctx = pending || collect(null);
    if (!ctx || !ctx.platform) return false;

    const wanted = norm(ctx.platform);
    const button = Array.from(root.querySelectorAll('[data-aw-config-platform]')).find((item) =>
      norm(item.dataset.awConfigPlatform) === wanted || norm(item.dataset.awConfigPlatformLabel) === wanted
    );
    if (!button) {
      console.warn('[AW Configurator P5] Contexte plateforme ignoré: aucune plateforme exacte trouvée.', ctx.platform);
      pending = null;
      return true;
    }

    syncing = true;
    try {
      const active = root.querySelector('[data-aw-config-platform][aria-pressed="true"]');
      if (active !== button) button.click();

      const manufacturer = root.querySelector('[data-aw-config-manufacturer]');
      const replicaType = root.querySelector('[data-aw-config-type]');
      const manufacturerValue = exactOptionValue(manufacturer, ctx.manufacturer);
      const typeValue = exactOptionValue(replicaType, ctx.replicaType);

      if (manufacturer && manufacturerValue && manufacturer.value !== manufacturerValue) {
        manufacturer.value = manufacturerValue;
        manufacturer.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (replicaType && typeValue && replicaType.value !== typeValue) {
        replicaType.value = typeValue;
        replicaType.dispatchEvent(new Event('change', { bubbles: true }));
      }
      pending = null;
      return true;
    } finally {
      syncing = false;
    }
  };
  const schedule = (detail) => {
    if (syncing) return;
    remember(detail);
    let tries = 0;
    const tick = () => {
      if (apply()) return;
      tries += 1;
      if (tries < 40) setTimeout(tick, 50);
    };
    tick();
  };

  // P2.2 — Transfer only an independently verified product platform.
  // Explicit shared/replica/platform contexts take precedence over aw_product.
  const productPlatform = () => {
    const result = window.AWConfiguratorP22Result;
    if (!result || result.status !== 'verified' || !text(result.platform)) return '';
    const params = new URLSearchParams(location.search);
    if (['aw_model', 'aw_platform', 'aw_config', 'aw_service', 'aw_replica', 'aw_owned_replica'].some((key) => !!params.get(key))) return '';
    return text(result.platform);
  };
  if (window.AWConfiguratorP22Ready) {
    Promise.resolve(window.AWConfiguratorP22Ready)
      .then(() => {
        const platform = productPlatform();
        if (platform && window.AWConfiguratorP22Blank !== true) schedule({ platform });
      })
      .catch(() => {});
  }

  remember(null);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => schedule(null), { once: true });
  } else {
    schedule(null);
  }

  ['aw:context-changed', 'aw:compatibility-changed', 'aw:platform-changed'].forEach((name) => {
    window.addEventListener(name, (event) => {
      if (!syncing) schedule(event && event.detail ? event.detail : null);
    });
  });
  document.addEventListener('shopify:section:load', (event) => {
    const target = event && event.target;
    if (target && ((target.matches && target.matches(ROOT)) || (target.querySelector && target.querySelector(ROOT)))) {
      schedule(null);
    }
  });
})();
